<template>
    <div class="ksBox">
        <div class="searchItem flex fle-item flex-just">
            <div class="item">
                <el-input
                        class="mr10"
                        placeholder="名称 搜索"
                        v-model="gsinput"
                        clearable>
                </el-input>
                <!--<el-select class="mr10" v-model="state" placeholder="请选择">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>-->
                <el-button type="primary" @click="searchData">检索</el-button>
            </div>
            <div class="item-right flex">
                <!--<div class="uploadFile">
                    <el-button type="info" class="uploadBtn">上传文件</el-button>
                    <input  type="file" name="files" value="" id="uploadfile2" multiple="multiple" accept=".xls"
                            class="upload-input uploadfile1" @change="importFile">
                </div>-->
                <div class="xz">
                    <el-button type="primary">新增</el-button>
                </div>
            </div>

        </div>
        <!--      表格-->
        <div class="dataTable mt20">
            <template>
                <el-table
                        :header-cell-style="{background:'#eef1f6',color:'#000'}"
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange">
                    <el-table-column
                            align="center"
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            prop="i_fid"
                            align="center"
                            label="编码"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="vc_name"
                            align="center"
                            label="名称"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_pname"
                            align="center"
                            label="省/市"
                            show-overflow-tooltip>
                    </el-table-column>
                    <!--<el-table-column
                            prop="vc_app"
                            align="center"
                            label="订阅系统"
                            width="120"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="vc_state"
                            align="center"
                            label="状态"
                            width="120"
                            :formatter="State"
                            show-overflow-tooltip>
                    </el-table-column>-->
                    <el-table-column
                            prop="dt_createtime"
                            align="center"
                            label="时间"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="操作"
                            width="160">
                        <template slot-scope="scope">
                            <!--                                        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>-->
                            <el-button type="text" size="small" style="color: #67C23A"  @click="relationData(scope.row)">查看关系 |</el-button>
                            <el-button type="text" size="small" style="color: #409EFF"  @click="editData(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="tableBottom flex fle-item flex-just mt20">
                    <div class="tbLeft">
                        <el-button type="primary">批量发布</el-button>
                        <el-button type="primary">批量归档</el-button>
                    </div>
                    <div class="tbRight">
                        <div class="paginationBox textRig" >
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    @current-change="pageCurrentChange"
                                    :current-page.sync="currentPage"
                                    :total="tableTotal">
                            </el-pagination>
                        </div>
                    </div>
                </div>

            </template>
        </div>
        <el-dialog title="关联数据"  :visible.sync="dialogFormVisibleData" v-if="dialogFormVisibleData" @close="cancelData" :close-on-click-modal="false" width="1250px" height="500px">
            <el-table tooltip-effect="dark" align="center" max-height="250" ref="singleTable" :data="GetChooseData"   @current-change="handleCurrentChangeZsj" highlight-current-row>
                <el-table-column width="" property="i_fid" label="编码" align="center"></el-table-column>
                <el-table-column width="" property="vc_name" label="名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column width="" property="vc_app" label="订阅系统" align="center"></el-table-column>
                <el-table-column width="" property="i_sysid" label="主数据id" align="center"></el-table-column>
                <el-table-column width="" property="i_appid" label="业务数据id" align="center"></el-table-column>
                <!--<el-table-column width="100" property="vc_bzstyle" label="包装规格" align="center"></el-table-column>
                <el-table-column width="100" property="f_weight" label="单件净重" align="center"></el-table-column>
                <el-table-column width="" property="vc_cd" label="产地" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column width="" property="vc_gykh" label="厂家" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column width="" property="vc_type" label="货物类型" align="center"show-overflow-tooltip></el-table-column>-->
                <el-table-column width="" property="dt_createtime" label="时间" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column width="" property="vc_user" label="账套" align="center"></el-table-column>
                <el-table-column
                        align="center"
                        label="操作"
                        width="">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" style="color: red" @click="noRelation(scope.row)">取消关系</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="编辑主数据"  :visible.sync="dialogFormVisibleEdit" v-if="dialogFormVisibleEdit" @close="cancelEdit" :close-on-click-modal="false" width="1250px" height="500px">
            <el-table tooltip-effect="dark" align="center"  ref="singleTable" :data="GetEditData" highlight-current-row>
                <el-table-column width="90" property="i_fid" label="编码" align="center"></el-table-column>
                <el-table-column width="" label="名称" property="vc_name" align="center" show-overflow-tooltip >
                    <template slot-scope="scope">
                        <el-input class="changeinput" label="scope.row.vc_name" v-model="svc_name"></el-input>
                    </template>
                </el-table-column>
                <el-table-column width="" label="省/市" property="vc_pname" align="center" show-overflow-tooltip >
                    <!--<template slot-scope="scope">
                        <el-input class="changeinput" label="scope.row.vc_pname" v-model="svc_pname"></el-input>
                    </template>-->
                </el-table-column>

                <!--                <el-table-column width="" property="vc_app" label="订阅系统" align="center"></el-table-column>-->
                <!--                <el-table-column width="" property="i_sysid" label="主数据id" align="center"></el-table-column>-->
                <!--                <el-table-column width="" property="i_appid" label="业务数据id" align="center"></el-table-column>-->
                <!--<el-table-column width="100" property="vc_bzstyle" label="包装规格" align="center" >
                    <template slot-scope="scope">
                        <el-input class="changeinput" label="scope.row.vc_bzstyle" v-model="svc_bzstyle"  ></el-input>
                    </template>
                </el-table-column>
                <el-table-column width="80" property="f_weight" label="单件净重" align="center">
                    <template slot-scope="scope">
                        <el-input class="changeinput" label="scope.row.f_weight" v-model="sf_weight"></el-input>
                    </template>
                </el-table-column>
                <el-table-column width="80" property="vc_unit" label="单位" align="center">
                    <template slot-scope="scope">
                        <el-input class="changeinput" label="scope.row.vc_unit" v-model="svc_unit"></el-input>
                    </template>
                </el-table-column>
                <el-table-column width="" property="vc_cd" label="产地" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input class="changeinput" label="scope.row.vc_cd" v-model="svc_cd" ></el-input>
                    </template>
                </el-table-column>
                <el-table-column width="" property="vc_gykh" label="厂家" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input class="changeinput" label="scope.row.vc_gykh" v-model="svc_gykh" ></el-input>
                    </template>
                </el-table-column>
                <el-table-column width="120" property="vc_type" label="货物类型" align="center"show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input class="changeinput" label="scope.row.vc_type" v-model="svc_type"></el-input>
                    </template>
                </el-table-column>-->
                                <el-table-column width="" property="dt_createtime" label="时间" align="center" show-overflow-tooltip></el-table-column>
                <!--                <el-table-column width="" property="vc_user" label="账套" align="center"></el-table-column>-->
                <el-table-column
                        align="center"
                        label="操作"
                        width="60">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" style="color: #67C23A" @click="saveChange(scope.row)">确定</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from  "./api";
    import {mapActions} from "vuex";
    import {filerequest_url} from './api';
    export default {
        name: "index",
        data(){
            return{
                chooseDataList:false,
                chooseData:false,
                isRelation:true,
                isHandle:false,
                state:"002",
                options: [{
                    value: '002',
                    label: '已处理'
                }, {
                    value: '003',
                    label: '异常'
                }],
                GetData:{
                    i_fid:"",
                    vc_app:"",
                    vc_name:"",
                    //vc_pname:"",
                    vc_bzstyle:"",
                    f_weight:"",
                    vc_cd:"",
                    vc_gykh:"",
                    vc_type:"",
                    vc_unit:"",
                    vc_user:"",
                },
                svc_bzstyle:"",
                svc_name:"",
                svc_pname:"",
                sf_weight:"",
                svc_type:"",
                svc_gykh:"",
                svc_cd:"",
                svc_unit:"",
                GetEditData:[],
                GetChooseData:[],
                dialogFormVisibleEdit:false,
                dialogFormVisibleData:false,
                gsinput:"",
                zsjinput:"",
                fileName:"",
                fileType:"",
                fileUrl:"",
                value:"",
                i_uid:"",
                tableData: [],
                tableTotal:0,
                pageSize:1,
                currentPage:1,
                glData:[],
                i_id:"",
                qi_id:"",
                qvc_user:"",
                //qvc_pname:"",
                qvc_name:"",
                qi_fid:"",
                yi_id:"",
                qvc_app:"",
                zColor:"backColor",
                cColor:"backColor",
                currentRow: null,
                zi_id:"",
            }
        },
        mounted() {
            this.getMDSysMessage();
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            async getMDSysMessage(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                };
                let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    page_size:this.pageSize,
                    // pageStart: (this.pageIndex-1)*this.pageSize,
                    page_count:10,
                    search:this.gsinput,
                    //vc_state:this.state,
                    i_type: 5,
                    tableData: [],
                };
                let res=await API.getMDSysMessage(param);
                if(res.code==1){
                    //console.log("res",res);
                    this.tableData= res.data;
                    this.tableTotal=res.count;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };

            },
            async searchPZdata(){
                let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    page_size:this.pageSize,
                    // pageStart: (this.pageIndex-1)*this.pageSize,
                    page_count:10,
                    search:this.gsinput,
                    vc_state:this.state,
                    i_type: 5,
                    tableData: [],
                };
                let res=await API.getMDSysMessage(param);
                if(res.code==1){
                    //console.log("res",res);
                    this.tableData= res.data;
                    this.tableTotal=res.count;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            async relationData(value){
//                console.log("value",value);
                this.currentRow="";
                this.isHandle=false;
                this.isRelation=true;
                this.qi_id=value.i_id;
                this.qi_fid=value.i_fid;
                this.qvc_app=value.vc_app;
                this.qvc_user=value.vc_user;
                this.qvc_name=value.vc_name;
                /*this.GetData.i_fid=value.i_fid;
                this.GetData.vc_name=value.vc_name;
                this.GetData.vc_bzstyle=value.vc_bzstyle;
                this.GetData.f_weight=value.f_weight;
                this.GetData.vc_cd=value.vc_cd;
                this.GetData.vc_gykh=value.vc_gykh;
                this.GetData.vc_unit=value.vc_unit;
                this.GetData.vc_type=value.vc_type;
                this.GetData.vc_user=value.vc_user;
                this.GetData.vc_app=value.vc_app;*/
                this.dialogFormVisibleData=true;
              //  console.log("qvc_name",this.qvc_name);
                let param={
                    i_id:this.qi_id,
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    //page_size:this.pageSize,
                    // pageStart: (this.pageIndex-1)*this.pageSize,
                    //page_count:10,
                    //search:this.qvc_name,
                    //vc_state:this.state,
                    i_type: 5,
                    //tableData: [],
                };
                let res=await API.getMDataDetails(param);
                if(res.code==1){
                    this.zsjinput=this.qvc_name;
                    this.chooseDataList=true;
                    //console.log("res",res);
                    this.GetChooseData= res.data;

                    //console.log("GetChooseData",typeof this.GetChooseData);
                    //this.tableTotal=res.count;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
                /*let param={
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    vc_name:value.vc_name,
                    i_type: 5,
                    //vc_pname:value.vc_pname,
                };
                let res=await API.getEditMessage(param);
                if(res.code==1){
                    //this.glData=res.data;
                    this.yi_id=res.data[0].i_id;
                    //this.vc_pname=res.data[0].vc_pname;
                    this.vc_name=res.data[0].vc_name;

                    if(this.qvc_name!=this.vc_name){
                        this.zColor="redColor";
                    }
                    // console.log("qvc_pname",this.qvc_pname,this.vc_pname);
                    // console.log("qvc_name",this.qvc_name,this.vc_name);
                } else if (res.code == -2) {
                    // this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };*/
            },
            async noRelation(value){
                //console.log("value",value);
                this.qi_id=value.i_sysid;
                this.qi_appid=value.i_appid;
                this.zi_id=value.i_id;
                let param={
                    i_id:this.zi_id,
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    i_appid:this.qi_appid,
                    i_sysid:this.qi_id,
                    //page_size:this.pageSize,
                    // pageStart: (this.pageIndex-1)*this.pageSize,
                    //page_count:10,
                    //search:this.qvc_name,
                    //vc_state:this.state,
                    i_type: 5,
                    //tableData: [],
                };
                let res=await API.delMDRelation(param);
                if(res.code==1){
                    //console.log("res",res);

                    this.$message.success(res.message);
                    this.GetChooseData= res.data;
                    //console.log("GetChooseData",typeof this.GetChooseData);
                    //this.tableTotal=res.count;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };
            },
            async editData(value){
                //console.log("value",value);
                this.svc_cd=value.vc_cd;
                this.sf_weight=value.f_weight;
                this.svc_bzstyle=value.vc_bzstyle;
                this.svc_name=value.vc_name;
                this.svc_pname=value.vc_pname;
                this.svc_gykh=value.vc_gykh;
                this.svc_type=value.vc_type;
                this.qi_id=value.i_id;
                this.qi_fid=value.i_fid;
                this.qvc_app=value.vc_app;
                this.qvc_user=value.vc_user;
                this.qvc_name=value.vc_name;
                this.GetEditData=[
                    {i_fid:value.i_fid,
                        vc_app:value.vc_app,
                        vc_name:value.vc_name,
                        vc_pname:value.vc_pname,
                        //vc_pname:"",
                        vc_bzstyle:value.vc_bzstyle,
                        f_weight:value.f_weight,
                        vc_cd:value.vc_cd,
                        vc_gykh:value.vc_gykh,
                        vc_type:value.vc_type,
                        vc_unit:value.vc_unit,
                        vc_user:value.vc_user,
                        dt_createtime:value.dt_createtime,}
                ];

                this.dialogFormVisibleEdit=true;
                //console.log("GetEditData",this.GetEditData);

            },
            async saveChange(value){
                //console.log("value",value);
                this.GetEditData=[
                    {i_fid:value.i_fid,
                        vc_app:value.vc_app,
                        vc_name:value.vc_name,
                        //vc_pname:"",
                        vc_bzstyle:value.vc_bzstyle,
                        f_weight:value.f_weight,
                        vc_cd:value.vc_cd,
                        vc_gykh:value.vc_gykh,
                        vc_type:value.vc_type,
                        vc_unit:value.vc_unit,
                        vc_user:value.vc_user,}
                ];
                this.dialogFormVisibleEdit=true;
                //console.log("GetEditData",this.GetEditData);
                let param={
                    i_id:this.qi_id,
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    vc_name:this.svc_name,
                    vc_pname:this.svc_pname,
                    i_type: 5,
                    //tableData: [],
                };
                let res=await API.updateMDMessage(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.dialogFormVisibleEdit=false;
                    this.getMDSysMessage();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                };

            },
            cancelData(){
                this.dialogFormVisibleData=false;
                this.cColor="backColor";
                this.zColor="backColor";
                this.currentRow="";
                this.GetChooseData=[];
                this.chooseDataList=false;
                this.chooseData=false;
            },
            cancelEdit(){
                this.dialogFormVisibleEdit=false;

            },
            State(row, column, cellValue, index){
                if(row.vc_state==='002'){
                    return '已处理'
                }else if(row.vc_state==='003'){
                    return '异常'
                }
            },
            pageCurrentChange(val){
                this.pageSize=val;
                this.currentPage=val;
                this.getMDSysMessage();
            },
            searchData(){
                this.pageSize=1;
                this.currentPage=1;
                this.searchPZdata();
            },
            handleSelectionChange:function(val) {
                this.multipleSelection = val;
                // console.log(val)
            },
            handleCurrentChangeZsj:function(val) {
                this.currentRow  = val;
                //console.log(val)
                if(this.currentRow!=null && this.currentRow!=""){
                    //this.glData=this.currentRow;
                    this.zi_id=this.currentRow.i_id;
                    this.chooseDataList=false;
                    this.chooseData=false;
                    this.isRelation=false;
                }
            },

        },
    }
</script>

<style lang="scss"  scoped>
    .flex{
        display: flex;
    }
    .fle-item{
        align-items: center;
    }
    .flex-just{
        justify-content: space-between;
    }
    .mr10{
        margin-right: 10px;
    }
    .mt20{
        margin-top: 20px;
    }
    .ksBox{
        height: 100%;
        margin-top: 20px;
    }
    .searchItem{
        .item{
            width: 30%;
            /deep/{


            }
        }
        .item-right{
            margin-right: 40px;
            .xz{
                margin-left: 10px;
            }
        }
    }
    .uploadFile{
        /*height: 80px;*/
        overflow: hidden;
        position: relative;
        .uploadBtn{
            width: 150px;
        }
        .upload-input{
            width: 150px;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
        }
    }
    .dataSpan{
        width: 100px;
        display: inline-block;
        padding-top: 10px;
    }
    .backColor{
        color: #606266;
    }
    .redColor{
        color: red;
    }
    /deep/{
        .el-dialog{
            font-size: 20px;
        }
        .el-dialog__header{
            background-color: #3e82e8;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
    }
</style>